export default __webpack_public_path__ + "static/media/group.c1b4692c.svg";